document.addEventListener("DOMContentLoaded", () => {
    const pageHandlers = {
        "/products/": productPageHandler,
    };

    const path = window.location.pathname;

    // Loop through keys to allow partial path matches if needed
    Object.keys(pageHandlers).forEach((key) => {
        if (path.startsWith(key)) {
            pageHandlers[key]();
        }
    });
});

function getConfigurationKey() {
    let sizeKey = null,
        materialKey = null;
    document.querySelectorAll('fieldset.variant-picker__option').forEach((fieldset) => {
        let legend = fieldset.querySelector('legend');
        if (legend) {
            let legendText = legend.innerText.toLowerCase().replace(/[^a-z0-9]/g, '');
            if (legendText === 'size') {
                sizeKey = fieldset.querySelector('input:checked').value;
            } else if (legendText === 'orientation') {
                materialKey = fieldset.querySelector('input:checked').value;
            }
        }
    });
    if (sizeKey && materialKey) {
        return sizeKey + '-' + materialKey;
    }
}

function loadConfiguration(key, canceled = 'false') {
    let sizeKey = key.split('-')[0],
        materialKey = key.split('-')[1];
    document.querySelector('product-rerender').setAttribute('data-canceled', canceled);
    document.querySelectorAll('fieldset.variant-picker__option').forEach((fieldset) => {
        let legend = fieldset.querySelector('legend');
        if (legend) {
            let legendText = legend.innerText.toLowerCase().replace(/[^a-z0-9]/g, '');
            if (legendText === 'size') {
                fieldset.querySelector(`input[value="${sizeKey}"]`).click();
            } else if (legendText === 'orientation') {
                fieldset.querySelector(`input[value="${materialKey}"]`).click();
            }
        }
    });
}

function printappProjectLoaded() {
    const printAppProject = document.getElementById('_printapp');
    if (printAppProject) {
        if (printAppProject.value && printAppProject.value.length !== 0) {
            return "true";
        }
    }
    return "false";
}

function productPageHandler(){
    // Hide the buy-now buttons by default
    const buyButtonsContainer = document.querySelector('.product-info__buy-buttons');
    const buyButtons = buyButtonsContainer.querySelector('.buy-buttons');
    buyButtons.style.display = 'none';

    // Set the configuration key
    document.querySelector('product-rerender').setAttribute('data-configuration-key', getConfigurationKey());

    // Catch changes from print.app hidden input
    const printAppObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.id === "_printapp") {
                    if (!node.value || node.value.length === 0) {
                        buyButtons.style.display = 'none';
                    } else {
                        buyButtons.style.display = '';
                    }
                    const valueObserver = new MutationObserver(() => {
                        if (node.value) {
                            if (node.value.length !== 0) {
                                let buyButtons = document.querySelector('.product-info .buy-buttons');
                                buyButtons.style.display = '';
                            }
                        }
                    });
                    valueObserver.observe(node, { attributes: true, attributeFilter: ['value'] });
                }
            });
        });
        if (printappProjectLoaded() === "true") {
            buyButtons.style.display = '';
        } else {
            buyButtons.style.display = 'none';
        }
    });
    printAppObserver.observe(buyButtonsContainer, { childList: true, subtree: true });

    // Catch changes from print.app previews
    const productGallery = document.querySelector('.product product-gallery');
    const productGalleryObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.classList.contains("printapp-previews")) { // Ensuring it's an element node
                    // Get the preview image src
                    const previewImageSrc = node.querySelector('img').src.split('.png')[0]+'.png';

                    // Check if print app's loaded preview was previously added to our cart, and clear the design
                    fetch('/cart.js')
                        .then(response => response.json())
                        .then(data => {
                            data.items.forEach((item, index) => {
                                if (item?.properties?.['_printapp-preview']) {
                                    let foo = {
                                        'property' : item.properties['_printapp-preview'],
                                        'imageSrc' : previewImageSrc,
                                    }
                                    if (item.properties['_printapp-preview'] === previewImageSrc) {
                                        // Clear the design
                                        let paButtons = document.getElementById('pa-buttons');
                                        if (paButtons) {
                                            paButtons.querySelectorAll('button').forEach((button) => {
                                                if (button.innerText === 'Clear Design') {
                                                    button.click();
                                                }
                                            });
                                        }
                                    }
                                }
                            });
                        })
                        .catch(error => console.error('Error fetching cart:', error));

                    // Else add the image preview to our cart line item properties
                    const hiddenInput = document.createElement("input");
                    hiddenInput.type = "hidden";
                    hiddenInput.id = "_printapp-preview";
                    hiddenInput.name = "properties[_printapp-preview]";
                    hiddenInput.value = previewImageSrc;

                    // Insert after the '_printapp-pdf-download' element
                    const printAppPdpDownload = document.getElementById("_printapp-pdf-download");
                    printAppPdpDownload.parentNode.insertBefore(hiddenInput, printAppPdpDownload.nextSibling);
                }
            });
        });
    });
    productGalleryObserver.observe(productGallery, { childList: true, subtree: true });

    // Catch changes from user
    document.addEventListener("variant:change", (event) => {
        let oldConfigurationKey = document.querySelector('product-rerender').getAttribute('data-configuration-key'),
            printAppProject = document.getElementById('_printapp'),
            buyButtons = document.querySelector('.product-info .buy-buttons'),
            newConfigurationKey = getConfigurationKey();
        if (oldConfigurationKey !== newConfigurationKey) {
            if (printAppProject) {
                if (printAppProject.value && printAppProject.value.length !== 0) {
                    const confirmClearDesign = confirm('Changing the size or orientation will clear your existing design. Would you like to continue?');
                    if (confirmClearDesign) {
                        let paButtons = document.getElementById('pa-buttons');
                        if (paButtons) {
                            paButtons.querySelectorAll('button').forEach((button) => {
                                if (button.innerText === 'Clear Design') {
                                    button.click();
                                }
                            });
                        }
                    } else {
                        loadConfiguration(oldConfigurationKey, 'true');
                    }
                }
            }
        }
        let projectLoaded = printappProjectLoaded();
        if (projectLoaded === "true") {
            buyButtons.style.display = '';
        } else {
            buyButtons.style.display = 'none';
        }
        document.querySelector('product-rerender').setAttribute('data-configuration-key', getConfigurationKey());
    });
}